module.exports = __webpack_public_path__ + "static/media/choithramsCornFlakesS.7914288d.png";